module.exports = __webpack_public_path__ + "static/media/p22.466d4316.png";